import React from 'react';
import { Box, Divider, Stack, TextField, Typography } from '@mui/material';

/**
 * Step 3 — EIP-2981 royalty config plus metadata base URI / external URL.
 *
 * Royalties are stored on chain as basis points (1% = 100 bps). The
 * input here shows the percent for UX and converts on change.
 */
export default function StepRoyalties({ form, setField }) {
  return (
    <Stack spacing='12px'>
      <Box>
        <Typography variant='body1' fontWeight='700' mb='6px'>Royalties (EIP-2981)</Typography>
        <Typography variant='body2' color='text.secondary'>
          Most marketplaces respect this on-chain royalty signal for resales.
        </Typography>
      </Box>
      <TextField
        size='small' type='number'
        label='Royalty %'
        inputProps={{ min: '0', max: '10000', step: '1' }}
        value={Number(form.royalty_basis_points) / 100}
        onChange={(e) => setField('royalty_basis_points', Math.round(Number(e.target.value) * 100))}
        fullWidth
        helperText={`Currently ${Number(form.royalty_basis_points || 0) / 100}% — stored on chain as basis points.`}
      />
      <TextField
        size='small'
        label='Royalty recipient address'
        value={form.royalty_recipient_address}
        onChange={(e) => setField('royalty_recipient_address', e.target.value)}
        placeholder='0x…'
        fullWidth
      />
      <Divider />
      <TextField
        size='small'
        label='Metadata base URI'
        value={form.metadata_base_uri}
        onChange={(e) => setField('metadata_base_uri', e.target.value)}
        placeholder='ipfs://… or https://…'
        fullWidth
        helperText="Token n's metadata is fetched from {baseURI}/n.json."
      />
      <TextField
        size='small'
        label='External URL'
        value={form.external_url}
        onChange={(e) => setField('external_url', e.target.value)}
        placeholder='https://your-brand.com'
        fullWidth
      />
    </Stack>
  );
}
